import React from 'react';
import { useLocale } from "src/providers/LocaleProvider";
import { Modal } from "@mui/material";
import { useStyles } from './styles';
import closeIcon from 'src/assets/icons/close.svg';

interface NonWinnerModalProps {
    open: boolean;
    onClose: () => void;
    place: number;
    tournamentTitle: string;
    maxParticipants: number;
}

const NonWinnerModal: React.FC<NonWinnerModalProps> = ({
    open,
    onClose,
    place,
    tournamentTitle,
    maxParticipants
}) => {
    const classes = useStyles();

    const {
        tournaments: {
            alerts: {
                tournamentTxt,
                finishedTxt,
                yourPlaceTxt,
                outTxt,
                betterLuck
            }
        }
    } = useLocale();

    const getPlaceText = (place: number) => {
        const suffix = place % 10 === 1 && place !== 11 ? 'st' :
            place % 10 === 2 && place !== 12 ? 'nd' :
                place % 10 === 3 && place !== 13 ? 'rd' : 'th';
        return `${place}${suffix}`;
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{
                backdropFilter: "blur(3px)",
                backgroundColor: "rgba(0, 0, 0, 0.3)"
            }}
        >
            <div className={classes.modalContent}>
                <img
                    src={closeIcon}
                    className={classes.closeButton}
                    onClick={onClose}
                />

                <div className={classes.modalDescription}>
                    <div className={classes.modalTitle}>
                        {tournamentTxt('Tournaments')} {tournamentTitle} {finishedTxt('finish')}!
                    </div>

                    <div className={classes.placeResult}>
                        <div className={classes.placeLabel}>{yourPlaceTxt('Your place')} </div>
                        <div className={classes.placeNumber}>
                            {getPlaceText(place)} {outTxt('out of')} {maxParticipants}
                        </div>
                    </div>

                    <div className={classes.encouragement}>
                        {betterLuck('Better luck next time')}!
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default NonWinnerModal;